import { Button, Flex } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { IconRedo, IconUndo } from "../../../assets/images/toolbar";

import { ActionCreators as UndoActionCreators } from "redux-undo";

export const UndoRedo = () => {
    const future = useSelector((state) => state.future);
    const past = useSelector((state) => state.past);

    const dispatch = useDispatch();

    return (
        <Flex className="device-view-items tenth-step">
            <Button
                type="text"
                icon={<IconUndo />}
                onClick={() => {
                    dispatch(UndoActionCreators.undo());
                }}
                disabled={past.length == 0}
            />
            <Button
                type="text"
                icon={<IconRedo />}
                onClick={() => {
                    dispatch(UndoActionCreators.redo());
                }}
                disabled={future.length == 0}
            />
        </Flex>
    );
};
